// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__NQ2Qv","smallIcon":"styles_smallIcon__2UVVz","svg":"styles_svg__3MpVh"};